export default "__VITE_ASSET__DdfK8i3N__"